import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { storage } from '@/utils/storage';

export default [
  {
    path: '/IFPageNinetyFourPreLogin',
    name: 'IFPageNinetyFourPreLogin',
    meta: {
      title: '星贷',
    },
    component: () => import('@/pages/pageListAll/pageNinetyFour/preLogin.vue'),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 20230727 返回拦截下载页 */
      if (from.path === '/IFPageNinetyFourLogin' || from.path === '/IFPageNinetyFourLoginSecond') {
        window.history.back();
      } else {
        next();
      }
    },
  },
  {
    path: '/IFPageNinetyFourLogin',
    name: 'pageNinetyFourLogin',
    meta: {
      title: '星贷',
    },
    component: () => import('@/pages/pageListAll/pageNinetyFour/login.vue'),
  },
  {
    path: '/IFPageNinetyFourLeaveInfo',
    name: 'pageNinetyFourLeaveInfo',
    meta: {
      title: '星贷',
    },
    component: () => import('@/pages/pageListAll/pageNinetyFour/leaveInfo.vue'),
  },
  {
    path: '/IFPageNinetyFourResult',
    name: 'pageNinetyFourResult',
    meta: {
      title: '星贷',
    },
    component: () => import('@/pages/pageListAll/pageNinetyFour/result.vue'),
  },
  {
    path: '/IFPageNinetyFourLoading',
    name: 'pageNinetyFourLoading',
    component: () => import('@/pages/pageListAll/pageNinetyFour/loading.vue'),
    meta: {
      title: '额度检测',
    },
  },
  {
    path: '/IFPageNinetyFourLoginSecond',
    name: 'pageNinetyFourLoginSecond',
    component: () => import('@/pages/pageListAll/pageNinetyFour/loginSecond.vue'),
    meta: {
      title: '星贷',
    },
  },
  {
    path: '/IFPageNinetyFourOnline',
    name: 'pageNinetyFourOnline',
    component: () => import('@/pages/pageListAll/pageNinetyFour/online.vue'),
    meta: {
      title: '星贷',
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 网贷来源页 */
      if (from.path == '/IFPageNinetyFourLoginSecond') {
        storage.setItem('onlineGoApply', null);
      } else {
        to.query.time = `${new Date().getTime()}`;
      }
      next();
    },
  },
  {
    path: '/IFPageNinetyFourGuide',
    name: 'pageNinetyFourLoginGuide',
    component: () => import('@/pages/pageListAll/pageNinetyFour/guide.vue'),
    meta: {
      title: '星贷',
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      to.query.formUrl = from.path;
      next();
    },
  },
  {
    path: '/IFPageNinetyFourCar',
    name: 'pageNinetyFourCar',
    component: () => import('@/pages/pageListAll/pageNinetyFour/car.vue'),
    meta: {
      title: '补充留资',
    },
  },
  {
    path: '/IFPageNinetyFourBlank',
    name: 'pageNinetyFourBlank',
    component: () => import('@/pages/pageListAll/pageNinetyFour/blank.vue'),
    meta: {
      title: '星贷',
    },
  },
  {
    path: '/IFPageNinetyFourOnlineTab',
    name: 'pageNinetyFourOnlineTab',
    component: () => import('@/pages/pageListAll/pageNinetyFour/onlineTab.vue'),
    meta: {
      title: '星贷',
    },
  },
];
